import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';

import { BingoConfig, BingoConfigProviderService, FeaturesClientConfig } from '@frontend/bingo/frontend-lib/core';

import { FeatureIconComponent } from '../../components/feature-icon/feature-icon.component';

@Component({
    selector: 'bg-tile-slider',
    templateUrl: './tile-slider.component.html',
    imports: [FeatureIconComponent, CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TileSliderComponent {
    @Input() RoomId: any;
    @Input() bingoType: any;
    @Input() roomName: any;
    @Input() isFavourite: any;
    @Input() favIcon: any;
    @Input() favMarkedIcon: any;
    @Input() feature: any;
    @Input() isTitle: boolean;
    @Output() closeSlider = new EventEmitter();

    content: any;
    featureContent: string;
    featureTitle: string;
    clientConfig: any;
    IsFavouriteEnabled: boolean = false;
    showIconImage: boolean = true;
    iconImageSrc: any;
    featureConfig: FeaturesClientConfig;
    isCozyUser: boolean = false;
    bingoconfig: BingoConfig;

    constructor(private configProviderService: BingoConfigProviderService) {
        this.featureConfig = this.configProviderService.provideFeaturesConfig();
        this.bingoconfig = this.configProviderService.provideBingoConfig();
    }

    ngOnInit() {
        this.clientConfig = JSON.parse(localStorage.getItem('config')!);
        if (localStorage.getItem('isFeatureicon') != 'false') {
            this.IsFavouriteEnabled = true;
            this.feature = this.roomName;
            this.featureContent = '';
            document.getElementById('slider-desc')!.innerHTML = this.findRoomDescriptionById(this.RoomId);
        } else {
            this.featureContent = this.clientConfig?.featureInformation[this.feature + '_content'];
        }
        this.featureTitle = this.clientConfig?.featureInformation[this.feature + '_title'];
        this.isCozyUser = this.featureConfig['enableNewCozyLobby'];
    }

    getBallTypeIconPath() {
        let ballTypeKey = this.bingoType + '-ball';
        return this.bingoconfig['bingoClientAssetsDomain'] + this.featureConfig?.ballTypeIconPaths?.[ballTypeKey];
    }

    findRoomDescriptionById(roomId: any) {
        for (let i = 0; i < this.clientConfig?.rooms.length; i++) {
            if (this.clientConfig?.rooms[i].roomId === roomId) {
                return this.clientConfig?.rooms[i].description;
            }
        }
        return this.clientConfig?.featureInformation['default'];
    }

    onSliderClose() {
        this.closeSlider.emit();
    }
}
